import store from "../store";


const getModificationData = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_PRODUCT_GET_DESIGN}design-data/${id}`);
        return await response.json();
    } catch (err) {
        store.status.error = err;
    }
}

export default getModificationData;